export default __webpack_public_path__ + "static/ThinkstockPhotos-467538074_article-52faba2e2b69bfa6a79b04f516c6bffc.jpg";